import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { createProjectDataToPayload } from '../mappers';
import { CreateProjectModel } from '../model/projectModel';

const getUrl = (host: string) => {
  return `${host}/projects`;
};

export const CreateProject = async ({ host, token, data }: { host: string; token: string; data: CreateProjectModel }): Promise<void> => {
  try {
    const url = getUrl(host);

    const mappedData = createProjectDataToPayload(data);

    const options: AxiosRequestConfig = {
      url,
      method: 'POST',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
